var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88118 19.3677L10.4167 14.8321L14.1879 18.6035L18.3971 14.3943L16.0066 12.0037H22.6732V18.6704L20.2827 16.2799L14.1879 22.3747L10.4167 18.6035L7.11783 21.9023C9.02882 24.7763 12.2965 26.6704 16.0066 26.6704C21.8976 26.6704 26.6732 21.8948 26.6732 16.0037C26.6732 10.1127 21.8976 5.33708 16.0066 5.33708C10.1155 5.33708 5.33988 10.1127 5.33988 16.0037C5.33988 17.1792 5.53 18.3101 5.88118 19.3677ZM3.83055 21.4453L3.81704 21.4319L3.8222 21.4267C3.08372 19.7699 2.67322 17.9348 2.67322 16.0037C2.67322 8.63994 8.64276 2.67041 16.0066 2.67041C23.3703 2.67041 29.3399 8.63994 29.3399 16.0037C29.3399 23.3676 23.3703 29.3371 16.0066 29.3371C10.581 29.3371 5.91239 26.0965 3.83055 21.4453Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundsLine);
export default __webpack_public_path__ + "static/media/funds-line.7ee107fe5c201cd39878d46bdd025665.svg";
export { ForwardRef as ReactComponent };